import React from 'react';
import { t } from 'i18next';
import { CourseModuleAboutAccordionItem } from './course-module-about-accordion-item';
import { FiInfo } from 'react-icons/fi';
import { CourseAbout, CourseAboutDeadline, CourseAboutDescription, CourseAboutTitle } from '@/components/custom/course';
import { Badge, BadgeGroup } from '@/components/ui/badge';
import { Accordion } from '@/components/ui/accordion';

export function CourseModuleAboutTabAbout({ currentModule }) {
  return (
    <CourseAbout className="animate-fade-in gap-0">
      <div className="flex flex-wrap-reverse items-end justify-between">
        <div className="mb-8">
          <CourseAboutTitle>{t('lms.titleAboutModule')}</CourseAboutTitle>
          {currentModule?.description && <CourseAboutDescription>{currentModule?.description}</CourseAboutDescription>}
        </div>

        <CourseAboutDeadline className="mb-6">
          <FiInfo size={20} />
          <span>
            O <b>certificado do módulo</b> estará disponível a partir de {new Date(currentModule?.['finished-at']).toLocaleDateString('pt-BR')}
          </span>
        </CourseAboutDeadline>
      </div>

      {currentModule?.['learning-system-subjects']?.length > 0 && (
        <div className="mb-8">
          <CourseAboutTitle>{t('lms.titleWhatLearn')}</CourseAboutTitle>
          {currentModule?.['learning-system-subjects']?.map(item => {
            return (
              <CourseAboutDescription>
                • {item.body} <br />
              </CourseAboutDescription>
            );
          })}
        </div>
      )}

      {currentModule?.['learning-system-requirements']?.length > 0 && (
        <div className="mb-8">
          <CourseAboutTitle>{currentModule?.['learning-system-requirements']?.length === 0 ? '' : t('lms.requirements')}</CourseAboutTitle>
          <BadgeGroup>
            {currentModule?.['learning-system-requirements']?.map(item => {
              return <Badge>{item.title}</Badge>;
            })}
          </BadgeGroup>
        </div>
      )}

      <div className="mb-8">
        <CourseAboutTitle>Disciplinas e aulas</CourseAboutTitle>

        <Accordion
          type="multiple"
          collapsible
        >
          {currentModule?.['learning-system-contents']?.map((item, index) => {
            const previousContent = index > 0 ? currentModule?.['learning-system-contents'][index - 1] : null;

            return (
              <CourseModuleAboutAccordionItem
                key={item.id}
                module={item}
                currentModule={currentModule}
                prevModule={previousContent}
              />
            );
          })}
        </Accordion>
      </div>
    </CourseAbout>
  );
}
